export const INPUT_PADDING = '0.8rem';

export const MOBILE_HEADER_MAX_WIDTH = 920; // px
